import { ATTENDANCE_API } from "../apis/attendance.api";
import { EMPLOYEE_API } from "../apis/employee.api";
import { EMPLOYEE_SERVICE_API } from "../apis/employee-service";
import { SYSTEM_CONFIGURATION_API } from "../apis/system-configuration.api";
import { REPORTS_API } from "../apis/reports.api";
import { PAYROLL_API } from "../apis/payroll.api";

/**
 * Mapping of base endpoints to enterprise equivalents
 * Maps relative paths (what comes after BASE_URL)
 */
export const ENTERPRISE_ENDPOINT_MAPPING: Record<string, string> = {
  "reports/main-dashboard": "enterprise/dashboard",
  attendances: "enterprise/attendance",
  // company setup
  branches: "enterprise/branches",
  departments: "enterprise/departments",
  jobs: "enterprise/jobs",
  positions: "enterprise/positions",
  employees: "enterprise/employees",
  // system configuration
  "grade-structure": "enterprise/grade-structure",
  "self-services/self-service-groups/": "enterprise/self-service-groups",
  "leave-types": "enterprise/leave-types",
  "permission-types": "enterprise/permission-types",
  "leave-plan-policies": "enterprise/leave-plan-policies",
  // recruitment
  "v1/recruitment/candidates": "enterprise/candidates",
  // attendance management
  "yearly-holidays": "enterprise/yearly-holidays",
  "work-schedules": "enterprise/work-schedules",
  "policy-groups": "enterprise/policy-groups",
  "rotation-groups": "enterprise/rotation-groups",
  eligibilities: "enterprise/eligibilities",
  // employee services
  [EMPLOYEE_SERVICE_API.GET_LEAVE_REQUEST_LIST]: "enterprise/leaves",
  [EMPLOYEE_SERVICE_API.GET_EMPLOYEES_LEAVES_LIST]: "enterprise/leave-balances",
  [EMPLOYEE_SERVICE_API.GET_PERMISSION_REQUEST_LIST]: "enterprise/permissions",
  [EMPLOYEE_SERVICE_API.GET_WORK_ON_VACATION_REQUEST_LIST]: "enterprise/work-on-vacation-orders",
  [EMPLOYEE_SERVICE_API.GET_BUSINESS_MISSION_REQUEST_LIST]: "enterprise/business-missions",
  [EMPLOYEE_SERVICE_API.GET_WORKING_FROM_HOME_REQUEST_LIST]: "enterprise/working-from-home",
  [EMPLOYEE_SERVICE_API.GET_OVERTIME_SUBMISSION_REQUEST_LIST]: "enterprise/overtime-submissions",
  // payroll setup
  [PAYROLL_API.GET_EXCHANGE_RATE_LIST]: "enterprise/exchange-rates",
  [PAYROLL_API.GET_SOCIAL_INSURANCE_LIST]: "enterprise/social-insurance",
  [PAYROLL_API.TAX_RULES_LIST]: "enterprise/tax-rules",
  [PAYROLL_API.GET_PAYROLL_ELEMENT_LIST]: "enterprise/elements",
  [PAYROLL_API.PAYROLL_DEFINITION_LIST]: "enterprise/payroll-definitions",
  [PAYROLL_API.GET_SALARY_STRUCTURE_LIST]: "enterprise/salary-structures",
  // reports
  [REPORTS_API.DAILY_STATUS_LIST]: "enterprise/employee-reports/",
  [PAYROLL_API.GET_PAYROLL_RUN_LIST]: "enterprise/payroll-runs",

  //export api
  [SYSTEM_CONFIGURATION_API.EXPORT_LEAVES]: "enterprise/leave-types/export",
  [SYSTEM_CONFIGURATION_API.EXPORT_PERMISSIONS_TYPES]: "enterprise/permission-types/export",
  [EMPLOYEE_API.EXPORT_EMPLOYEE]: "enterprise/employees/export",
  [ATTENDANCE_API.EXPORT_ATTENDANCES]: "enterprise/attendance/export",
  [EMPLOYEE_SERVICE_API.EXPORT_LEAVE_REQUEST]: "enterprise/requests/leave_request/export/",
  [EMPLOYEE_SERVICE_API.EXPORT_PERMISSION_REQUEST]:
    "enterprise/requests/permission_request/export/",
  [EMPLOYEE_SERVICE_API.EXPORT_WORKING_FROM_HOME_REQUEST]:
    "enterprise/requests/working_from_home_request/export/",
  [EMPLOYEE_SERVICE_API.EXPORT_OVERTIME_SUBMISSION_REQUEST]:
    "enterprise/requests/overtime_amount_submission_request/export/",
  [EMPLOYEE_SERVICE_API.EXPORT_WORK_ON_VACATION_ORDER_REQUEST]:
    "enterprise/requests/work_on_vacation_order_request/export/",
  [EMPLOYEE_SERVICE_API.EXPORT_BUSINESS_MISSION_REQUEST]:
    "enterprise/requests/business_mission_request/export/",
  [REPORTS_API.ANNUAL_ACCUMULATED_EXPORT]: "enterprise/annual-accumulated/export/",
} as const;
